// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"X1-z","displaySixCardTiles":"Y1-z"};